import { createSelector, createReducer } from '@reduxjs/toolkit';
import {
  getRequestData,
  selectAllFromApiState,
} from '../helpers/selectorHelpers';
import { updateDtoList } from '../helpers/reducerHelpers';
import {
  getAllInvitationSourcesInitialize,
  getAllInvitationSourcesSuccess,
} from '../actions/api';
import { all, call, fork, takeEvery } from 'redux-saga/effects';
import { InvitationSourceConnector } from '../connectors/invitationSourceConnector';
import { generateGetAllApiCall } from '../helpers/sagaHelpers';

// -------- Overview --------

// The following endpoints exist
//  - GET /InvitationSource

// InvitationSource is included in the following endpoints
//  - ???

// -------- Reducer --------
const invitationSourceReducer = createReducer(
  {
    all: [],
  },
  (builder) => {
    builder.addCase(getAllInvitationSourcesSuccess, (state, action) => {
      const invitationSources = getRequestData(action);
      return updateDtoList(state, 'all', invitationSources);
    });
  },
);

// -------- Sagas ---------
export function* invitationSourceSaga() {
  yield all([fork(getAllInvitationSourcesSaga)]);
}

function* getAllInvitationSourcesSaga() {
  yield takeEvery(
    getAllInvitationSourcesInitialize.type,
    generateGetAllApiCall(InvitationSourceConnector, function* (connector) {
      return yield call([connector, connector.getInvitationSources]);
    }),
  );
}

// -------- Selectors --------
const selectGetAllInvitationSources = (state) =>
  selectAllFromApiState(state, 'invitationSource');

const allInvitationSourcesSelector = createSelector(
  selectGetAllInvitationSources,
  (invitationSources) => invitationSources,
);

// -------- Exporting --------
export { allInvitationSourcesSelector };
export default invitationSourceReducer;
